<template>
  <div v-if="showTab === 3">
    <md-card-content>
      <table class="flex-table td-text-align-right">
        <tr>
          <th>지부</th>
          <td>{{ formatter.getCurrency(branchTotalData['J']['feeRowCnt']) }} 건</td>
          <td>{{ formatter.getCurrency(branchTotalData['J']['feeCnt']) }} 명</td>
          <td>{{ formatter.getCurrency(branchTotalData['J']['feeAmt']) }} 원</td>
        </tr>
        <tr>
          <th>분회</th>
          <td>{{ formatter.getCurrency(branchTotalData['B']['feeRowCnt']) }} 건</td>
          <td>{{ formatter.getCurrency(branchTotalData['B']['feeCnt']) }} 명</td>
          <td>{{ formatter.getCurrency(branchTotalData['B']['feeAmt']) }} 원</td>
        </tr>
        <tr>
          <th>합계</th>
          <td>{{ formatter.getCurrency(branchTotalData['J']['feeRowCnt'] + branchTotalData['B']['feeRowCnt']) }} 건</td>
          <td>{{ formatter.getCurrency(branchTotalData['J']['feeCnt'] + branchTotalData['B']['feeCnt']) }} 명</td>
          <td>{{ formatter.getCurrency(branchTotalData['J']['feeAmt'] + branchTotalData['B']['feeAmt']) }} 원</td>
        </tr>
      </table>
      <div class="table-header-info">
        <div>총 {{ formatter.getCurrency(branchTotalData['J']['feeRowCnt'] + branchTotalData['B']['feeRowCnt']) }} 건의 검색결과가 있습니다.</div>       
      </div>

      <md-table :value="branchData" class="paginated-table table-striped table-hover text-align-center h500">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="지부/분회ID">{{ item.branchId }}</md-table-cell>
          <md-table-cell md-label="지부/분회명">
            <a :href="'/MembershipFee/GroupManagement/' + item.branchId + '/' + item.branchNm + '/' + item.branchGb">
              {{ item.branchNm }}
            </a>
          </md-table-cell>
          <md-table-cell md-label="납부일자">{{ item.feeDate }}</md-table-cell>
          <md-table-cell md-label="회비년도">{{ item.feeYear }}</md-table-cell>
          <md-table-cell md-label="금액" style="text-align: right;">{{ formatter.getCurrency(item.feeAmt) }} 원</md-table-cell>
          <md-table-cell md-label="납부인원수" style="text-align: right;">{{ item.feeCnt }} 명</md-table-cell>
          <md-table-cell md-label="납부방법">{{ item.feeWayNm }}</md-table-cell>
        </md-table-row>
      </md-table>

<!-- 
      <grid ref="paymentListGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @response="response"
      ></grid> -->


    </md-card-content>

    <md-card-actions md-alignment="space-between">
      <div class="md-alignment-space-between-right">
        <md-button class="md-success md-sm" :disabled="branchData.length === 0" @click="downloadExcel" v-exel-btn="[5,3]">
          <md-icon>get_app</md-icon>Excel 다운로드
        </md-button>
      </div>
    </md-card-actions>
  </div>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  name: "PaymentListBranchComp",
  props: {
    showTab : {
      type : Number,
      default : 1
    }
  },
  components: {
  //  grid: Grid
  },

  created() {
   // this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      formatter,
      branchTotalData : {
        "B" : { "branchGb": "B", "feeRowCnt": 0, "branchNm": "분회", "feeAmt": 0, "feeCnt": 0},
        "J" : { "branchGb": "J", "feeRowCnt": 0, "branchNm": "지부", "feeAmt": 0, "feeCnt": 0}
      },
      branchData : [],
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 150, 100, 200, 500],
        total: 0
      },
      option: {}
    };
  },
  methods: {
    sendQuery (query) {
      this.option = query ? query : {};
      this.option['feeGb'] = '02';
      this.option.perPage = 100000;
      this.option.page = 1;
      kuaaApi.sendServer(
        URL_CONST.GET_FEE_LIST_TOTAL,
        this.option,
        "post",
        (response) => {
	      this.branchTotalData = {
	      	"B" : { "branchGb": "B", "feeRowCnt": 0, "branchNm": "분회", "feeAmt": 0, "feeCnt": 0},
	      	"J" : { "branchGb": "J", "feeRowCnt": 0, "branchNm": "지부", "feeAmt": 0, "feeCnt": 0}
	      };
          let resBranchTotalData = response.data.data.contents.branchFeeTotalInfo;
          resBranchTotalData.forEach((obj)=>{
            if(obj['branchGb']){
              this.branchTotalData[obj['branchGb']] = obj;
            }
          });
          this.pagination.total = response.data.data.contents.branchFeeListInfo.length;
          this.branchData = response.data.data.contents.branchFeeListInfo;
        }
      );
    },
    // perPageChange(event) {
    //   kuaaFnc.resetPagenation(this.$refs.paymentListGrid, event, this.pagination);
    // },
    // initGrid() {
    //   this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_FEE_LIST_TOTAL, false, this.pagination);
    //   this.gridProps['el'] = this.$refs.paymentListGrid;
    //   this.gridProps['columns']= [
    //       {header: '지부/분회ID', name: 'branchId', sortable: true},
    //       {header: '지부/분회명', name: 'branchNm', sortable: true},
    //       {header: '납부일자', name: 'feeDate', sortable: true},
    //       {header: '회비년도', name: 'feeYear', sortable: true},
    //       {header: '금액', name: 'feeAmt', sortable: true},
    //       {header: '납부인원수', name: 'feeCnt', sortable: true},
    //       {header: '납부방법', name: 'feeWay', sortable: true}
    //     ];
    // },
    // response(e) {
    //   let res = JSON.parse(e.xhr.response);
    //   if(res.result){
    //     this.pagination.total = res.data.pagination.totalCount;
    //
    //     //this.$refs.paymentListGrid.invoke("resetData", response.data.data.contents.branchFeeListInfo, {});
    //   }else{
    //     kuaaFnc.gridErrorCallback(e,"지부/분회 납부리스트");
    //   }
    // },
     downloadExcel() { 
      if(this.pagination.total > 100000){
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드 대상은 100,000건 이하여야 합니다.");
        return false;
      }
            
      this.option.page = 1;
      this.option.perPage = this.pagination.total;
      this.option.fileName = '납부상세내역(지부_분회_납부리스트)';
      kuaaApi.requestFileDownload(
          URL_CONST.FEE_LIST_EXCEL_DOWNLOAD,
          this.option,
          '납부상세내역(지부_분회_납부리스트).xlsx',
          response => {
            this.option.page = this.pagination.page;
            this.option.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>
  table > thead{
    position: sticky;
    top: 0;
  }
</style>